var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTree5Dark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86.93 111.72",
    style: {
      enableBackground: "new 0 0 86.93 111.72"
    },
    xmlSpace: "preserve",
    overflow: "visible",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.td50{fill:#D4D3D7;}\n\t.td51{fill:#6C401D;}\n\t.td52{fill:#0C6A37;}\n\t.td53{fill:#0D5229;}\n\t.st0{transform-origin: 50% 50%; transform-box: fill-box;}\n\t.st1{transform-origin: 50% 100%; transform-box: fill-box;}\n\t.st2{transform-origin: 50% 100%; transform-box: fill-box;}\n\t.st3{transform-origin: 50% 100%; transform-box: fill-box;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0 td50",
    cx: 43.52,
    cy: 106.08,
    rx: 31.4,
    ry: 5.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.02,
    y: 95.08,
    className: "st1 td51",
    width: 9,
    height: 12.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2 td52",
    d: "M71.22,45.45c0.02-0.47,0.03-0.95,0.03-1.43c0-10.15-4.53-16.12-11.49-21.65c0.05-0.66,0.08-1.33,0.08-1.99 C59.84,9.12,52.54,0,43.52,0S27.2,9.12,27.2,20.38c0,0.67,0.03,1.33,0.08,1.99c-6.95,5.53-11.49,11.51-11.49,21.65 c0,0.48,0.01,0.96,0.03,1.43C11.4,47.84,8.2,55.54,8.48,61.19C3.36,62.28,0,67.43,0,71.76c0,15.03,19.89,24.65,43.52,24.65 s43.41-9.06,43.41-24.09c0-4.16-3.02-9.42-7.35-11.16C79.58,56.13,75.84,47.95,71.22,45.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3 td53",
    d: "M43.52,85.57c-16.25,0-31.3-3.36-42.78-8.93C4,87.8,21.26,96.41,43.52,96.41s39.4-7.7,42.83-19.77 C74.87,82.21,59.77,85.57,43.52,85.57z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTree5Dark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tree5_dark.0a2ec13b79cdee47b26d20aee9f5d4ef.svg";